/* ============================================================
   SIGMA CULT — Shopify theme JS
   Cart drawer (AJAX API), quick-add, search, sliders
   ============================================================ */
(function () {
  const CFG = window.SigmaCult || {};
  const fmt = cents => "EGP " + (cents / 100).toLocaleString("en-EG", { maximumFractionDigits: 0 });
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => [...(root || document).querySelectorAll(sel)];

  /* ---------- Toast ---------- */
  function toast(msg) {
    const t = $("#toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("on");
    clearTimeout(t._h);
    t._h = setTimeout(() => t.classList.remove("on"), 2200);
  }

  /* ---------- Cart drawer ---------- */
  async function fetchCart() {
    const res = await fetch("/cart.js");
    return res.json();
  }

  function renderCart(cart) {
    const host = $("#cartItems");
    if (!host) return;
    $("#cartCount").textContent = cart.item_count;
    $("#cartHeadCount").textContent = cart.item_count ? `(${cart.item_count})` : "";

    const spFill = $("#spFill"), spText = $("#spText");
    if (spFill && CFG.freeShip) {
      const pct = Math.min(100, Math.round(cart.total_price / CFG.freeShip * 100));
      spFill.style.width = pct + "%";
      spFill.classList.toggle("full", cart.total_price >= CFG.freeShip);
      spText.innerHTML = cart.total_price >= CFG.freeShip
        ? "🎉 You've unlocked <b>free shipping</b>!"
        : `You're <b>${fmt(CFG.freeShip - cart.total_price)}</b> away from free shipping`;
    } else {
      // no free-shipping threshold — hide the meter entirely rather than
      // leaving an empty bar in the drawer
      const sp = $("#shipProgress");
      if (sp) sp.style.display = "none";
    }

    if (!cart.items.length) {
      host.innerHTML = `<div class="cart-empty">Your cart is empty.<a class="btn btn-ghost" href="/collections/all">Shop Designs</a></div>`;
      $("#cartTotal").textContent = fmt(0);
      return;
    }
    host.innerHTML = cart.items.map((item, idx) => `
      <div class="cart-item">
        <a href="${item.url}"><img src="${item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, "_200x$1$2") : ""}" alt=""></a>
        <div>
          <h4>${item.product_title}</h4>
          <div class="meta">${item.variant_title || ""}</div>
          <div class="qty">
            <button data-line="${idx + 1}" data-q="${item.quantity - 1}" aria-label="Decrease">−</button>
            <span>${item.quantity}</span>
            <button data-line="${idx + 1}" data-q="${item.quantity + 1}" aria-label="Increase">+</button>
          </div>
        </div>
        <div style="text-align:right">
          <div class="line-price">${fmt(item.final_line_price)}</div>
          <button class="rm" data-line="${idx + 1}" data-q="0">Remove</button>
        </div>
      </div>`).join("");
    $("#cartTotal").textContent = fmt(cart.total_price);

    $$("#cartItems [data-line]").forEach(b => b.addEventListener("click", async () => {
      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: +b.dataset.line, quantity: +b.dataset.q })
      });
      renderCart(await res.json());
    }));
  }

  function openCart() {
    $("#cartDrawer").classList.add("open");
    $("#veil").classList.add("open");
    document.body.classList.add("no-scroll");
  }
  function closeCart() {
    $("#cartDrawer").classList.remove("open");
    closeQuickAdd();
    $("#veil").classList.remove("open");
    document.body.classList.remove("no-scroll");
  }

  async function addToCart(variantId, qty) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      toast(err.description || "Couldn't add to cart");
      return;
    }
    renderCart(await fetchCart());
    toast("Added to cart ✓");
    openCart();
  }

  async function checkoutWhatsApp() {
    const cart = await fetchCart();
    if (!cart.items.length) { toast("Your cart is empty"); return; }
    const lines = cart.items.map(i =>
      `• ${i.product_title} — ${i.variant_title || ""} × ${i.quantity} = ${fmt(i.final_line_price)}`);
    const msg = encodeURIComponent(
      `Hi ${CFG.shopName}! I'd like to order:\n\n${lines.join("\n")}\n\nTotal: ${fmt(cart.total_price)}\n\nName:\nAddress:\nPhone:`);
    window.open(`https://wa.me/${CFG.waNumber}?text=${msg}`, "_blank");
  }

  /* ---------- Quick-add sheet ---------- */
  function closeQuickAdd() {
    const sheet = $("#qaSheet");
    if (!sheet) return;
    sheet.classList.remove("open");
    if (!$("#cartDrawer").classList.contains("open")) {
      $("#veil").classList.remove("open");
      document.body.classList.remove("no-scroll");
    }
  }

  function wireQuickAdd(root) {
    $$("[data-quick-add]", root).forEach(btn => {
      if (btn._wired) return; btn._wired = true;
      btn.addEventListener("click", () => {
        const card = btn.closest(".product-card");
        const data = JSON.parse($("[data-product-json]", card).textContent);
        const sheet = $("#qaSheet");
        const priceHtml = data.compare > data.price
          ? `<s>${fmt(data.compare)}</s>${fmt(data.price)}` : fmt(data.price);
        sheet.innerHTML = `
          <div class="qa-head">
            <img src="${data.image}" style="object-position:${data.crop} 22%" alt="">
            <div>
              <h4>${data.title}</h4>
              <div class="qa-game">${data.vendor || ""}</div>
              <div class="qa-price">${priceHtml}</div>
            </div>
            <button class="qa-close" aria-label="Close">&times;</button>
          </div>
          <div class="qa-label">Select size · box fit, true to size</div>
          <div class="size-opts">
            ${data.variants.map(v =>
              `<button data-vid="${v.id}" ${v.available ? "" : "disabled"}>${v.title}</button>`).join("")}
          </div>`;
        sheet.classList.add("open");
        $("#veil").classList.add("open");
        $(".qa-close", sheet).addEventListener("click", closeQuickAdd);
        $$("[data-vid]", sheet).forEach(b => b.addEventListener("click", () => {
          addToCart(+b.dataset.vid, 1);
          closeQuickAdd();
        }));
      });
    });
  }

  /* ---------- Search (predictive) ---------- */
  function openSearch() {
    $("#searchOverlay").classList.add("open");
    document.body.classList.add("no-scroll");
    setTimeout(() => $("#searchInput").focus(), 80);
  }
  function closeSearch() {
    $("#searchOverlay").classList.remove("open");
    document.body.classList.remove("no-scroll");
  }
  let searchTimer;
  async function runSearch(q) {
    const res = $("#searchResults"), empty = $("#searchEmpty"), hint = $("#searchHint");
    if (!q.trim()) { res.innerHTML = ""; empty.hidden = true; hint.textContent = "Type to search the drop"; return; }
    const r = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10`);
    const data = await r.json();
    const products = data.resources.results.products || [];
    hint.textContent = `${products.length} result${products.length === 1 ? "" : "s"} for "${q}"`;
    res.innerHTML = products.map(p => `
      <div class="product-card">
        <div class="frame-wrap">
          <a class="frame" href="${p.url}">
            <img loading="lazy" src="${p.featured_image ? p.featured_image.url : ""}" alt="${p.title}">
          </a>
        </div>
        <div class="card-info">
          ${p.vendor ? `<div class="card-game">${p.vendor}</div>` : ""}
          <h3><a href="${p.url}">${p.title}</a></h3>
          <div class="card-price">${p.price ? "EGP " + p.price : ""}</div>
        </div>
      </div>`).join("");
    empty.hidden = products.length > 0;
  }

  /* ---------- Hero slider ---------- */
  function initHero() {
    const hero = $("[data-hero]");
    if (!hero) return;
    const slides = $$(".hero-slide", hero);
    if (slides.length < 2) { $("[data-hero-dots]", hero)?.remove(); return; }
    const dots = $("[data-hero-dots]", hero);
    slides.forEach((_, i) => {
      const b = document.createElement("button");
      if (i === 0) b.classList.add("on");
      b.setAttribute("aria-label", "Slide " + (i + 1));
      b.addEventListener("click", () => go(i, true));
      dots.appendChild(b);
    });
    let cur = 0, timer;
    function go(i, manual) {
      slides[cur].classList.remove("on");
      dots.children[cur].classList.remove("on");
      cur = (i + slides.length) % slides.length;
      slides[cur].classList.add("on");
      dots.children[cur].classList.add("on");
      if (manual) { clearInterval(timer); timer = setInterval(() => go(cur + 1), 5200); }
    }
    timer = setInterval(() => go(cur + 1), 5200);
    $("[data-hero-prev]", hero)?.addEventListener("click", () => go(cur - 1, true));
    $("[data-hero-next]", hero)?.addEventListener("click", () => go(cur + 1, true));
    let sx = null;
    hero.addEventListener("touchstart", e => sx = e.touches[0].clientX, { passive: true });
    hero.addEventListener("touchend", e => {
      if (sx === null) return;
      const dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 45) go(cur + (dx < 0 ? 1 : -1), true);
      sx = null;
    }, { passive: true });
  }

  /* ---------- Row arrows ---------- */
  function initRows() {
    $$(".carousel-wrap").forEach(wrap => {
      const row = $("[data-row]", wrap);
      if (!row) return;
      const step = () => {
        const card = $(".product-card", row);
        return card ? card.getBoundingClientRect().width + 20 : 300;
      };
      $("[data-row-prev]", wrap)?.addEventListener("click", () => row.scrollBy({ left: -step(), behavior: "smooth" }));
      $("[data-row-next]", wrap)?.addEventListener("click", () => row.scrollBy({ left: step(), behavior: "smooth" }));
    });
  }

  /* ---------- Product page ---------- */
  function initProduct() {
    const addBtn = $("#addBtn");
    if (!addBtn) return;
    let qty = 1;
    let variantId = $("#onlyVariant") ? +$("#onlyVariant").value : null;
    const picker = $("#variantPicker");
    if (picker) {
      const on = $("button.on", picker);
      if (on) variantId = +on.dataset.variantId;
      $$("button", picker).forEach(b => b.addEventListener("click", () => {
        $$("button", picker).forEach(x => x.classList.remove("on"));
        b.classList.add("on");
        variantId = +b.dataset.variantId;
        const lbl = $("#sizeLabel");
        if (lbl) lbl.textContent = b.dataset.variantTitle;
      }));
    }
    const basePrice = +addBtn.dataset.price || 0;
    const sync = () => {
      $("#qVal").textContent = qty;
      if (basePrice) addBtn.textContent = `Add to Cart — ${fmt(basePrice * qty)}`;
    };
    $("#qMinus")?.addEventListener("click", () => { if (qty > 1) { qty--; sync(); } });
    $("#qPlus")?.addEventListener("click", () => { qty++; sync(); });
    addBtn.addEventListener("click", () => variantId && addToCart(variantId, qty));
    $("#saAdd")?.addEventListener("click", () => variantId && addToCart(variantId, qty));

    // thumbs
    $$(".thumbs img").forEach(t => t.addEventListener("click", () => {
      $("#mainImg").src = t.dataset.full;
      $$(".thumbs img").forEach(x => x.classList.remove("on"));
      t.classList.add("on");
    }));

    // sticky bar
    window.addEventListener("scroll", () => {
      const past = addBtn.getBoundingClientRect().bottom < 0;
      $("#stickyAtc")?.classList.toggle("show", past);
    }, { passive: true });

    // size guide
    $("#sgOpen")?.addEventListener("click", () => $("#sgModal").classList.add("open"));
    $("#sgClose")?.addEventListener("click", () => $("#sgModal").classList.remove("open"));
    $("#sgModal")?.addEventListener("click", e => {
      if (e.target.id === "sgModal") e.target.classList.remove("open");
    });
  }

  /* ---------- Collection sort ---------- */
  function initSort() {
    $("[data-sort]")?.addEventListener("change", e => {
      const url = new URL(location.href);
      url.searchParams.set("sort_by", e.target.value);
      location.href = url.toString();
    });
  }

  /* ---------- Shared init ---------- */
  document.addEventListener("DOMContentLoaded", async () => {
    // announcement rotation
    const spans = $$("#announcement span");
    let ai = 0;
    if (spans.length > 1) setInterval(() => {
      spans[ai].classList.remove("on");
      ai = (ai + 1) % spans.length;
      spans[ai].classList.add("on");
    }, 4200);

    // header hide on scroll down
    let lastY = window.scrollY;
    const wrap = $("#headerWrap");
    window.addEventListener("scroll", () => {
      const y = window.scrollY;
      wrap?.classList.toggle("hide", y > 180 && y > lastY);
      lastY = y;
    }, { passive: true });

    $("#cartBtn")?.addEventListener("click", openCart);
    $("#cartClose")?.addEventListener("click", closeCart);
    $("#veil")?.addEventListener("click", () => { closeCart(); $("#navDrawer")?.classList.remove("open"); });
    $("#checkoutBtn")?.addEventListener("click", () => location.href = "/checkout");
    $("#checkoutWa")?.addEventListener("click", checkoutWhatsApp);

    $("#burger")?.addEventListener("click", () => {
      $("#navDrawer").classList.add("open");
      $("#veil").classList.add("open");
      document.body.classList.add("no-scroll");
    });
    $("#navClose")?.addEventListener("click", () => {
      $("#navDrawer").classList.remove("open");
      $("#veil").classList.remove("open");
      document.body.classList.remove("no-scroll");
    });

    $("#searchBtn")?.addEventListener("click", openSearch);
    $("#searchClose")?.addEventListener("click", closeSearch);
    $("#searchInput")?.addEventListener("input", e => {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => runSearch(e.target.value), 220);
    });
    document.addEventListener("keydown", e => {
      if (e.key === "Escape") { closeSearch(); closeCart(); closeQuickAdd(); $("#navDrawer")?.classList.remove("open"); }
    });

    // marquee duplication
    const track = $("[data-marquee]");
    if (track) track.innerHTML += track.innerHTML;

    initHero();
    initRows();
    initProduct();
    initSort();
    wireQuickAdd(document);
    renderCart(await fetchCart());
  });
})();
